import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// native components
import SitemapAboutUsSection from '../sitemapAboutUsSection/sitemapAboutUsSection';
import SitemapFinancialPlanningSection from '../sitemapFinancialPlanningSection/sitemapFinancialPlanningSection';
import SitemapForOurClientsSection from '../sitemapForOurClientsSection/sitemapForOurClientsSection';
import SitemapInsuranceSection from '../sitemapInsuranceSection/sitemapInsuranceSection';
import SitemapInvestmentsSection from '../sitemapInvestmentsSection/sitemapInvestmentsSection';
import SitemapLifeAndMoneySection from '../sitemapLifeAndMoneySection/sitemapLifeAndMoneySection';
import SitemapOtherHelpfulLinksSection from '../sitemapOtherHelpfulLinksSection/sitemapOtherHelpfulLinksSection';

export default () => (
  <SectionContainer
    id='sitemap'
    disableBottomPadding>
    <Row align='center'>
      <Col align='center'>
        <Typography
          component='h1'
          nextElement='graphic'>
          Northwestern Mutual Sitemap
        </Typography>
      </Col>
    </Row>
    <Row align='center'>
      <SitemapAboutUsSection />
      <SitemapFinancialPlanningSection />
      <SitemapInsuranceSection />
      <SitemapInvestmentsSection/>
      <SitemapLifeAndMoneySection />
      <SitemapForOurClientsSection />
    </Row>
    <Row align='left'>
      <SitemapOtherHelpfulLinksSection />
    </Row>
  </SectionContainer>
);
